import { useAuthorization } from "@/hooks/use-authorization";
import type { EntityType } from "@/schemas/digital-files";
import { Permissions } from "@/utils/permissions";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Icon,
} from "@elaniintc/goes-design-system";
import { Link } from "react-router";

interface EntityActionsProps {
  entity: EntityType | null;
  onActivate: (id: string) => void;
  onDeactivate: (id: string) => void;
  onReactivate: (id: string) => void;
}
export const EntityActions = ({
  entity,
  onActivate,
  onDeactivate,
  onReactivate,
}: EntityActionsProps) => {
  const { hasPermission } = useAuthorization();
  const canUpdate = hasPermission(Permissions.expedient_base_entities.update);
  const isDraft = entity?.status?.toLowerCase() === "draft";
  const isActive = entity?.status?.toLowerCase() === "active";
  const isInactive = entity?.status?.toLowerCase() === "inactive";

  if (!entity) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="tertiary" size="icon" aria-label="Opciones">
          <Icon type="far" name="ellipsis-v" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="w-48 rounded-lg border-neutral-silent text-body font-normal"
        side="bottom"
        align="end"
        sideOffset={4}
      >
        {canUpdate && isActive && (
          <>
            <DropdownMenuItem asChild>
              <Link
                to={`/expedientes/entidad/${entity.id}/registro`}
                className="justify-between"
              >
                Agregar registro <Icon type="far" name="plus" />
              </Link>
            </DropdownMenuItem>
            <hr className="border-neutral-quiet w-[95%] mx-auto" />
          </>
        )}
        {canUpdate && (
          <DropdownMenuItem asChild>
            <Link
              to={`/expedientes/entidad/${entity.id}`}
              className="hover:bg-neutral-object-accent-silent text-body cursor-pointer"
            >
              Editar entidad
            </Link>
          </DropdownMenuItem>
        )}
        {canUpdate && isDraft && (
          <DropdownMenuItem
            className="cursor-pointer"
            onClick={() => onActivate(entity.id)}
          >
            Activar
          </DropdownMenuItem>
        )}
        {canUpdate && isActive && (
          <DropdownMenuItem
            className="cursor-pointer"
            onClick={() => onDeactivate(entity.id)}
          >
            Desactivar
          </DropdownMenuItem>
        )}
        {canUpdate && isInactive && (
          <DropdownMenuItem
            className="cursor-pointer"
            onClick={() => onReactivate(entity.id)}
          >
            Reactivar
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
